import { api } from './api';

export interface RewardType {
  id: number;
  name: string;
  description: string;
  points: number;
  icon?: string;
  category: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface UserReward {
  id: number;
  userId: number;
  rewardTypeId: number;
  points: number;
  message?: string;
  createdAt: string;
  rewardType?: RewardType;
}

export interface UserPoints {
  userId: number;
  total: number;
  level: number;
  nextLevel: number;
  nextLevelThreshold: number | null;
  progress: number;
}

export interface UserStreak {
  userId: number;
  streakDays: number;
  lastLoginAt: string;
  loginCount: number;
  streakUpdated: boolean;
}

export interface UserBadges {
  userId: number;
  existingBadges: string[];
  newBadges: string[];
  allBadges: string[];
}

export interface Badge {
  id: number;
  name: string;
  description: string;
  icon?: string;
  condition: string;
  threshold: number;
  category: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export const rewardsService = {
  // Récupération des types de récompenses
  getRewardTypes: async (): Promise<RewardType[]> => {
    try {
      const response = await api.get('/api/rewards/types');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des types de récompenses:', error);
      return [];
    }
  },

  // Récupération des récompenses de l'utilisateur courant
  getUserRewards: async (): Promise<UserReward[]> => {
    try {
      const response = await api.get('/api/rewards/me/rewards');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des récompenses utilisateur:', error);
      return [];
    }
  },

  // Récupération des points de l'utilisateur courant
  getUserPoints: async (): Promise<UserPoints | null> => {
    try {
      const response = await api.get('/api/rewards/me/points');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des points utilisateur:', error);
      return null;
    }
  },

  // Mise à jour de la série de connexions
  updateLoginStreak: async (): Promise<UserStreak | null> => {
    try {
      const response = await api.post('/api/rewards/me/login-streak');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour de la série de connexions:', error);
      return null;
    }
  },

  // Vérification et attribution des badges
  checkBadges: async (): Promise<UserBadges | null> => {
    try {
      const response = await api.post('/api/rewards/me/check-badges');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la vérification des badges:', error);
      return null;
    }
  },

  // Partage d'un événement (pour attribution de points)
  shareEvent: async (eventId: number, platform: string): Promise<any> => {
    try {
      const response = await api.post(`/api/events/${eventId}/share`, { platform });
      return response.data;
    } catch (error) {
      console.error('Erreur lors du partage de l\'événement:', error);
      throw error;
    }
  }
};
